import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getRegisterProgress = api(async function getRegisterProgress(id) {
    return query(
        gql`
            query GetRegisterProgress($id: String!) {
                getRegisterProgress(id: $id) {
                    message
                    lastBlockSize
                    remaining
                    total
                    startedAt
                    finished
                    error
                }
            }
        `,
        { id },
        { returns: "getRegisterProgress" }
    )
})
